import React, { useEffect, useState, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { createPhotoForAccident, deletePhoto, getAccidentById } from '../redux/apiCalls/accidentApiCall';
import { toast } from 'react-toastify';
import { FaDownload, FaCamera, FaTimes, FaCheck } from 'react-icons/fa';
import { ClipLoader } from "react-spinners";
import { RiDeleteBin6Line } from "react-icons/ri";
const Altschaden = () => {
    const dispatch = useDispatch();
    const fileInputRef = useRef(null);
        const videoRef = useRef(null);
        const canvasRef = useRef(null);
    const { lastAccident, createPhotoLoading } = useSelector(state => state.accident);
    const [selectedFile, setSelectedFile] = useState(null);
    const [isCameraOpen, setIsCameraOpen] = useState(false);

        // فتح الكاميرا في وضع ملء الشاشة
        const openCamera = async () => {
            setIsCameraOpen(true);
            try {
                const stream = await navigator.mediaDevices.getUserMedia({ video: true });
                if (videoRef.current) {
                    videoRef.current.srcObject = stream;
                }
            } catch (error) {
                console.error("Error accessing camera:", error);
                toast.error("Kamera konnte nicht geöffnet werden.");
            }
        };

        // إغلاق الكاميرا
                const closeCamera = () => {
                    setIsCameraOpen(false);
                    if (videoRef.current && videoRef.current.srcObject) {
                        const stream = videoRef.current.srcObject;
                        const tracks = stream.getTracks();
                        tracks.forEach(track => track.stop());
                    }
                };

            // التقاط الصورة
    const capturePhoto = () => {
        if (!videoRef.current || !canvasRef.current) return;
        
        const video = videoRef.current;
        const canvas = canvasRef.current;
        const context = canvas.getContext('2d');
        
        canvas.width = video.videoWidth;
        canvas.height = video.videoHeight;
        context.drawImage(video, 0, 0, canvas.width, canvas.height);

        canvas.toBlob((blob) => {
            const file = new File([blob], "captured_photo.jpg", { type: "image/jpeg" });
            setSelectedFile(file);
            closeCamera();
        }, "image/jpeg");
    };
    useEffect(() => {
        dispatch(getAccidentById(lastAccident._id));
    }, [dispatch, lastAccident._id]);

    const handleFileChange = (event) => {
        setSelectedFile(event.target.files[0]);
    };
    // تحميل الصورة إلى السيرفر
    const handleSend = () => {
        if (selectedFile) {
            const formData = new FormData();
            formData.append('image', selectedFile);
            formData.append("accident", lastAccident._id);
            formData.append("kind", "Altschaden");
            dispatch(createPhotoForAccident(formData));
        } else {
            toast.error("Please select a file first.");
        }
    };
    const downloadPhoto = async (url, fileName = "	Altschaden") => {
        try {
            const response = await fetch(url);
            const blob = await response.blob();
            const link = document.createElement("a");
            link.href = URL.createObjectURL(blob);
            link.download = fileName;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            URL.revokeObjectURL(link.href); 
        } catch (error) {
            console.error("Error downloading the file:", error);
            toast.error("Failed to download the file.");
        }
    };
    return (
        <div className="flex flex-col items-center justify-center h-screen space-y-4">

<div className="grid grid-cols-4 gap-4 p-4">
    {lastAccident.photos?.map((e) => (
        e.kind === "Altschaden" && (
            <div key={e._id} className="relative w-full">
                <div className="w-full aspect-[4/3] overflow-hidden rounded-lg">
                    <img
                        src={e.photo?.url}
                        className="w-full h-full object-cover"
                        alt="Accident Photo"
                    />
                </div>
                <div className='flex flex-col'>
                <button
                    onClick={() => downloadPhoto(e.photo?.url, "10Mal")}
                    className="absolute top-2 left-2 p-2 bg-opacity-60 bg-gray-800 rounded-full"
                >
                    <FaDownload color="white" size={20} />
                </button>
                <button
    onClick={() => dispatch(deletePhoto(e._id))}
    className="absolute top-12 left-2 p-2 bg-opacity-60 bg-red-500 rounded-full"
>
    <RiDeleteBin6Line color="white" size={20} />
</button>
                </div>
            </div>
        )
    ))}
</div>

            <div className="flex items-center justify-between w-[25%] ">
            <button
                onClick={openCamera}
                className="bg-blue-500 text-white p-3 rounded-lg flex items-center space-x-2"
            >
                <FaCamera />
                <span>Kamera öffnen</span>
            </button>
            
            {isCameraOpen && (
                <div className="fixed inset-0 bg-black bg-opacity-90 flex flex-col items-center justify-center z-50">
                    <video ref={videoRef} autoPlay className="w-full h-full object-cover"></video>
                    <div className="absolute bottom-8 flex space-x-4">
                        <button onClick={capturePhoto} className="bg-green-500 text-white p-3 rounded-full">
                            <FaCheck size={24} />
                        </button>
                        <button onClick={closeCamera} className="bg-red-500 text-white p-3 rounded-full">
                            <FaTimes size={24} />
                        </button>
                    </div>
                </div>
            )}
            <input
                type="file"
                onChange={(e) => setSelectedFile(e.target.files[0])}
                ref={fileInputRef}
                className="hidden"
                id="fileInput"
            />
            <label htmlFor="fileInput" className="mt-2 block text-sm text-gray-500 py-2 px-4 rounded-lg border border-gray-300 bg-blue-50 text-blue-700 hover:bg-blue-100 cursor-pointer">
            Datei auswählen
            </label>
            </div>
                        <button
                            onClick={handleSend}
                            className="bg-[rgb(255,140,0)] text-white p-3 rounded-lg"
                        >
                            {createPhotoLoading ? <ClipLoader color="white" size={20} /> : "schicken"}
                        </button>
                        <canvas ref={canvasRef} className="hidden"></canvas>
        </div>
    );
};

export default Altschaden;
